import React,{useCallback}from'react';import PropTypes from'prop-types';import {useHistory}from'react-router-dom';import {MenuItem}from'@manulife/mux';import usePathBuilder from'../../../hooks/usePathBuilder.js';import FormattedRichMessage from'../../FormattedRichMessage/FormattedRichMessage.js';function ManageId(props) {
  var absoluteCiamDomain = props.absoluteCiamDomain;
  var pathBuilder = usePathBuilder();
  var history = useHistory();
  var handleClick = useCallback(function () {
    var relativePath = pathBuilder('/manageid');
    if (absoluteCiamDomain) {
      window.location.href = "".concat(absoluteCiamDomain).concat(relativePath);
    } else {
      history.push(relativePath);
    }
  }, [pathBuilder, absoluteCiamDomain, history]);
  return /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleClick,
    label: /*#__PURE__*/React.createElement(FormattedRichMessage, {
      id: "shared.layout.utilityBar.manageId"
    })
  });
}
process.env.NODE_ENV !== "production" ? ManageId.propTypes = {
  absoluteCiamDomain: PropTypes.string
} : void 0;
ManageId.defaultProps = {
  absoluteCiamDomain: ''
};export{ManageId as default};